import styled from "styled-components";
import {Person, Quote, QuoteState, Scope, StyledBaseProps} from "@betrue/shared/interfaces";
import {
  Avatar,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from "@mui/material";
import {FileLink, QuoteListProps} from "@betrue/ui";
import HighlightOffOutlinedIcon from "@mui/icons-material/HighlightOffOutlined";
import React, {useState} from "react";
import moment from "moment";
import {personAvatarUrl} from "@betrue/front/services";

export interface QuoteListViewProps extends StyledBaseProps, QuoteListProps {
  currentUser: Person,
  quotes: Quote[],
  onAcceptQuote: (quote: Quote) => void,
  onDeclineQuote: (quote: Quote) => void,
  deleteQuote: (quote: Quote) => void,
}

export const QuoteListView = styled((props: QuoteListViewProps) => {
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false)
  const [confirmQuote, setConfirmQuote] = useState<Quote>()

  const handlePay = (quote: Quote) => {
    setConfirmQuote(quote)
    setOpenConfirmDialog(true)
  }
  return (<div className={props.className}>
    <Dialog
      open={openConfirmDialog}
      disableAutoFocus={true}
      disableEnforceFocus={true}
      disableRestoreFocus={true}
      disablePortal={true}
      onClose={() => setOpenConfirmDialog(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        {props.quoteRefLabel}: {confirmQuote?.reference}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          <p>{props.acceptQuoteConfirmText}</p>
          <p>{props.quoteSubmitter}:</p><Typography
          variant={'h5'}> {confirmQuote?.submitter?.firstName} {confirmQuote?.submitter?.lastName}</Typography>
          <p>{props.amountLabel}:</p> <Typography
          variant={'h5'}>{confirmQuote?.amount}€</Typography>
          <p>{props.fileLabel}:</p> <FileLink removable={false} file={confirmQuote?.file}/>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button color={'secondary'} variant={'outlined'}
                onClick={() => setOpenConfirmDialog(false)}> {props.cancelLabel}</Button>
        <Button color={'primary'} variant={'outlined'} onClick={() => {
          console.log(confirmQuote,'confirmQuote')
          props.onDeclineQuote(confirmQuote)
          setOpenConfirmDialog(false)
        }}
                autoFocus>
          {props.declineLabel}
        </Button>
        <Button color={'primary'} variant={'outlined'} onClick={() => {
          props.onAcceptQuote(confirmQuote)
          setOpenConfirmDialog(false)
        }}
                autoFocus>
          {props.acceptLabel}
        </Button>

      </DialogActions>
    </Dialog>
    <TableContainer style={{maxHeight: '500px', overflow: 'scroll'}}>
      <Table stickyHeader size="small" aria-label="a dense table">
        <TableHead>
          <TableRow>

            {props.currentUser.scope === Scope.EMPLOYEE ?
              (<TableCell align="left">
                {props.partnerLabel}
              </TableCell>) : ''}

            <TableCell align="left">
              {props.quoteRefLabel}
            </TableCell>
            <TableCell align="left">
              {props.amountUntaxeLabel}
            </TableCell>
            <TableCell align="left">
              {props.amountLabel}
            </TableCell>
            <TableCell align="left">
              {props.creationDateLabel}
            </TableCell>
            <TableCell align="left">
              {props.fileLabel}
            </TableCell>
            <TableCell align="left">
              {props.removeLabel}
            </TableCell>
            <TableCell align="left">
              {props.actionLabel}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {(props.quotes)
            .map((quote) => (
              <TableRow key={quote.id}>
                {props.currentUser.scope === Scope.EMPLOYEE ? (
                  <TableCell component="th" scope="row" align="left">
                    <Chip
                      avatar={<Avatar
                        alt={`${quote.submitter.firstName} ${quote.submitter.lastName}`}
                        src={personAvatarUrl(quote.submitter)}/>}
                      label={`${quote.submitter.firstName} ${quote.submitter.lastName}`}
                    />
                  </TableCell>) : ('')}
                <TableCell component="th" scope="row" align="left">
                  {quote.reference}
                </TableCell>
                <TableCell align="left">
                  {quote.amountUntaxed}€
                </TableCell>
                <TableCell align="left">
                  {quote.amount}€
                </TableCell>
                <TableCell align="left">
                  {moment(quote.quoteDate).locale('fr').format("ll")}
                </TableCell>
                <TableCell align="left">
                  <FileLink removable={false} file={quote.file}/>
                </TableCell>
                <TableCell align="left">
                  <IconButton disabled={quote.state !== QuoteState.PENDING}
                              onClick={(e) => props.deleteQuote(quote)}>
                    <HighlightOffOutlinedIcon/>
                  </IconButton>
                </TableCell>
                {props.currentUser.scope === Scope.EMPLOYEE && quote.state === QuoteState.PENDING ? (
                  <TableCell align="left">
                    <Button color={'primary'} variant={'outlined'}
                            onClick={() => handlePay(quote)}>{props.actionLabel}</Button>
                  </TableCell>
                ) : (

                <TableCell align="left">
                  <Chip
                    color={quote.state === QuoteState.PENDING ? 'default' : 'primary'}
                    label={quote.state}/>
                </TableCell>
                  )}
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </TableContainer>
  </div>)
})``
